/* ==========================================================================
   Productpagina — eigen "Koop nu"-knop naast "Toevoegen aan winkelwagen".
   Teksten nu vertaalbaar via window.hotpotProductStrings.
   ========================================================================== */

(function () {
  'use strict';

  var strings = window.hotpotProductStrings || {
    buyNow: 'Buy now',
    adding: 'Processing...',
    failed: 'Failed, please try again'
  };

  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('product-form form');

    forms.forEach(function (form) {
      var submitContainer = form.querySelector('.product-form__buttons');
      if (!submitContainer || submitContainer.querySelector('[data-hotpot-buy-now]')) return;

      var buyNowButton = document.createElement('button');
      buyNowButton.type = 'button';
      buyNowButton.className = 'hotpot-buy-now-button';
      buyNowButton.setAttribute('data-hotpot-buy-now', '');
      buyNowButton.textContent = strings.buyNow;

      buyNowButton.addEventListener('click', function () {
        var variantInput = form.querySelector('input[name="id"], select[name="id"]');
        var quantityInput = form.querySelector('input[name="quantity"]');
        var variantId = variantInput ? variantInput.value : null;
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        if (!variantId) return;

        buyNowButton.disabled = true;
        buyNowButton.textContent = strings.adding;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Toevoegen mislukt');
            return response.json();
          })
          .then(function () {
            window.location.href = '/checkout';
          })
          .catch(function () {
            buyNowButton.disabled = false;
            buyNowButton.textContent = strings.failed;
          });
      });

      submitContainer.appendChild(buyNowButton);
    });
  });
})();